import React, { Component } from "react";
import { Row, Col, Button, Modal, Container, Form } from "react-bootstrap";
import Switch from "react-switch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

class EditPaymentMode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: {
        payMode: this.props.ItemList ? this.props.ItemList.name : null,
        payModeDescp: this.props.ItemList ? this.props.ItemList.disc : null,

        id: this.props.ItemList ? this.props.ItemList.id : null,
      },
    };
  }
  onChange = (event) => {
    let name = event.target.name;
    let value = event.target.value;
    if (name === "payMode") {
      this.setState({
        value: { ...this.state.value, payMode: value },
      });
    } else if (name === "payModeDescp") {
      this.setState({
        value: { ...this.state.value, payModeDescp: value },
      });
    }
  };
  submit = () => {
    let data = this.state.value;

    if (data.payMode !== "" && data.payModeDescp !== "") {
      this.props.EditPaymentMode(this.state.value);

      this.props.closeEditModel();
      this.props.resetPage();
    } else {
      toast.error("Please fill all required fields", {
        autoClose: 2000,
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: {
        payMode: nextProps.ItemList && nextProps.ItemList.name,
        payModeDescp: nextProps.ItemList && nextProps.ItemList.disc,

        id: nextProps.ItemList && nextProps.ItemList.id,
      },
    });
  }

  render() {
    return (
      <div>
        <Modal
          show={this.props.showpaymodeEditModel}
          onHide={this.props.closeEditModel}
          animation={false}
          size="md"
          backdrop="static"
        >
          <Modal.Header
            style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
            closeButton
          >
            <Modal.Title>Payment Mode</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container>
              <Row>
                <Col lg={12}>
                  <Form>
                    <div style={{ maxWidth: 280, margin: "auto" }}>
                      <div>
                        <Form.Group controlId="payMode">
                          <Form.Label> Name </Form.Label>
                          <Form.Control
                            type="text"
                            autoComplete="off"
                            name="payMode"
                            onChange={this.onChange}
                            value={this.state.value.payMode}
                          />
                        </Form.Group>
                      </div>

                      <div>
                        <Form.Group controlId="payModeDescp">
                          <Form.Label>Description</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="payModeDescp"
                            autoComplete="off"
                            onChange={this.onChange}
                            value={this.state.value.payModeDescp}
                          />
                        </Form.Group>
                      </div>
                    </div>
                  </Form>
                </Col>
              </Row>
            </Container>
          </Modal.Body>
          <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}>
            <Button type="submit" onClick={this.submit}>
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default EditPaymentMode;
